type BadgeVariant =
  | "default"
  | "primary"
  | "success"
  | "destructive"
  | "warning"
  | "plum"
  | "pine"
  | "ochre"
  | "indigo"
  | "moss";

/** Mirrors the attribute tag names inserted by backend/scripts/migration-prune-attribute-tags.sql. */
const KNOWN_VARIANTS: Record<string, BadgeVariant> = Object.assign(Object.create(null), {
  "Female Founded": "plum",
  "Black Owned": "pine",
  "LGBTQ+ Owned": "indigo",
  "Gluten Free Kitchen": "ochre",
  "Nut Free Kitchen": "moss",
});

const PRECEDENCE = Object.keys(KNOWN_VARIANTS);

function precedenceOf(name: string): number {
  const index = PRECEDENCE.indexOf(name);
  return index === -1 ? PRECEDENCE.length : index;
}

export function attributeTagVariant(tag: { name: string }): BadgeVariant {
  return KNOWN_VARIANTS[tag.name] ?? "default";
}

export function compareAttributeTags(a: { name: string }, b: { name: string }): number {
  return precedenceOf(a.name) - precedenceOf(b.name) || a.name.localeCompare(b.name);
}
